import { useWindowSize, useMeasure } from 'react-use';
import type { UseMeasureRef } from 'react-use/lib/useMeasure';

export interface LayoutSizes {
  componentHeight: number;
  pageHeight: number;
  appBarHeight: number;
  appBarRef: UseMeasureRef<Element>;
  bottomNavMenuHeight: number;
  bottomNavMenuRef: UseMeasureRef<Element>;
}

export interface LayoutSizesWithTabs extends LayoutSizes {
  tabBarHeight: number;
  tabBarRef: UseMeasureRef<Element>;
}

export function useLayoutSizes(): LayoutSizes {
  const { height: pageHeight } = useWindowSize();
  const [appBarRef, { height: appBarHeight }] = useMeasure();
  const [bottomNavMenuRef, { height: bottomNavMenuHeight }] = useMeasure();
  const componentHeight = pageHeight - appBarHeight - bottomNavMenuHeight;

  return {
    componentHeight,
    pageHeight,
    appBarHeight,
    appBarRef,
    bottomNavMenuHeight,
    bottomNavMenuRef,
  };
}

export function useLayoutSizesWithTabs(): LayoutSizesWithTabs {
  const {
    componentHeight,
    pageHeight,
    appBarHeight,
    appBarRef,
    bottomNavMenuHeight,
    bottomNavMenuRef,
  } = useLayoutSizes();
  const [tabBarRef, { height: tabBarHeight }] = useMeasure();
  const newComponentHeight = componentHeight - tabBarHeight;

  return {
    componentHeight: newComponentHeight,
    pageHeight,
    appBarHeight,
    appBarRef,
    bottomNavMenuHeight,
    bottomNavMenuRef,
    tabBarHeight,
    tabBarRef,
  };
}
